// extracted by mini-css-extract-plugin
module.exports = {"selectContent":"Simplebutton_selectContent__QgLWs"};